import React from 'react';
import { Controller } from 'react-hook-form';
import FormGroup from '@mui/material/FormGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import IOSSwitch from '#component/project/dashboard/switch';

const RHFSwitch = ({
  name,
  control,
  label,
  rules,
  ...rest
}) => (
  <Controller
    name={name}
    control={control}
    rules={rules}
    render={({ field: { value, onChange, ...field } }) => (
      <FormGroup>
        <FormControlLabel
          control={
            <IOSSwitch
              checked={!!value}
              onChange={e => onChange(e.target.checked)}
              {...field}
              {...rest}
            />
          }
          label={label}
        />
      </FormGroup>
    )}
  />
);

export default RHFSwitch;
